import React from 'react';
import PropTypes from 'prop-types';
import { Errors } from 'react-redux-form';

import './styles/RRFValidationErrors.scss';

const RRFValidationErrors = ({ formObject: { form, model }, fieldNames }) => (
  !form.$form.valid && (
    <div className='alert alert-danger'>
      <strong>There were errors processing this form.</strong>
      &nbsp;Please review the issues marked below.

      <ul className='rrf-validation-errors-list'>
        {
          (Object.keys(model).concat(['base'])).map((k) => (
            <Errors
              key={k}
              model={`${form.$form.model}.${k}`}
              wrapper={(f) => (
                <li>
                  {
                    k !== 'base' && (
                      <span>
                        {(fieldNames[k] || k)}
                        :&nbsp;
                      </span>
                    )
                  }
                  {f.children}
                </li>
              )}
            />
          ))
        }
      </ul>

    </div>
  )
);

RRFValidationErrors.propTypes = {
  fieldNames: PropTypes.shape({
    [PropTypes.string]: PropTypes.string
  }),
  formObject: PropTypes.shape({
    form: PropTypes.shape({
      $form: PropTypes.shape({
        valid: PropTypes.bool
      })
    }),
    model: PropTypes.shape({
      _id: PropTypes.string
    })
  })
};

RRFValidationErrors.defaultProps = {
  fieldNames: {},
  formObject: {}
};

export default RRFValidationErrors;
